<template>
  <div id="app" v-if="agaMain.data != null">
    <div id="title">Ouvrages de l'AGA</div>
    <div id="filters">
      <div id="filterTitle">Filtres</div>

    <div v-if="false">
      <div class="filterSubTitle">Recherche simple</div>
      <div class="filteritem">
        <label for="free">entrez le(s) mot(s) à rechercher</label>
        <input type="text" id="free" v-model="agaMain.freeFilter">
      </div>
      <div class="searchButton" @click="freeSearch">RECHERCHER</div>
    </div>

    <div id="advSearch">
       <div v-if="false" class="filterSubTitle">Recherche avancée</div>
      <div
        v-for="(filter,filterIndex) in agaMain.data.categories"
        v-bind:key="filterIndex"
        class="filteritem"
      >
        <div class="filterTitle">{{filter.title}}</div>
        
        <select
          class="combobox"
          v-model="agaMain.filters[filterIndex]"
        >
          <option 
            value="null"
          ></option>
          <option 
            v-for="(field, fieldIndex) in filter.values"
            v-bind:key="fieldIndex"
            v-bind:value="field"
          >
              {{field.name}}
          </option>
        </select>
      </div>
      <div class="searchButton" @click="classicSearch">RECHERCHER</div>
      <div id="reinit" class="searchButton" @click="resetSearch">RÉINITIALISER LES FILTRES</div>
      <div id="legend">■ : Ouvrages papier encore disponibles à la vente</div>
    </div>


    </div>

    <div id="bulletins">
      <div
        class="bulletinItem"
        v-for="(bulletin, bulletinIndex) in agaMain.filteredBulletins"
        v-bind:key="bulletinIndex"
      >
        <div class="bulletin" @click="openInNewTab(bulletin.url)">

          <div
            class="bulletinTitle"
          >{{bulletin.title}} n° {{bulletin.num}} année : {{bulletin.year}}</div>

          <div 
            class="matchingSubjects"
            v-for="(subject, subjectIndex) in bulletin.subjects"
            v-bind:key="subjectIndex"
          >
              page n° {{subject.page}} : {{subject.title}} 

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import agaMain from "./js/agaMain.js";

export default {
  name: "App",
  components: {},
  data: function() {
    return {
      agaMain: new agaMain(this)
    };
  },
  mounted() {
    this.agaMain.init();
  },
  methods: {
    openInNewTab(url) {
      var fullURL = this.agaMain.serverURL + "/pdf/" + url;
      this.agaMain.log(fullURL);
      var win = window.open(fullURL, "_blank");
      win.focus();
    },
    freeSearch(){
      for(var i=0; i< this.agaMain.filters.length; i++)
        this.agaMain.filters[i] = "null";
      this.agaMain.filterFree();
    },
    classicSearch(){
      this.agaMain.freeFilter = "";
      this.agaMain.filterBulletins()
    },
    resetSearch(){
      for(var i=0; i< this.agaMain.filters.length; i++)
        this.agaMain.filters[i] = "null";
      this.agaMain.freeFilter = "";
      this.agaMain.filteredBulletins = this.agaMain.data.bulletins
    }
  }
};
</script>

<style src="./assets/css/main.css"></style>